import React from "react";
import { SortableElement } from "react-sortable-hoc";
import MatchTestElement from "../../../../../assets/components/Match/MatchTestElement";

const OrderListElement = ({ text, id }) => {
  return <MatchTestElement index={id} text={text} type={"order"} />;
};
export default SortableElement(OrderListElement);
